module.exports = __webpack_public_path__ + "static/img/简易版.82a0656d.webp";